<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="销项" v-if="findChildren(27)!==-1" name="invoiceoutput" style="height: 100%;">
				<invoiceoutput-index />
			</el-tab-pane>
			<el-tab-pane label="品类" v-if="findChildren(25)!==-1" name="invoicetype" style="height: 100%;">
				<invoicetype-index />
			</el-tab-pane>
			<el-tab-pane label="进项" v-if="findChildren(26)!==-1" name="invoiceinput" style="height: 100%;">
				<invoiceinput-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import invoicetypeIndex from './invoicetype/index.vue'
	import invoiceinputIndex from './invoiceinput/index.vue'
	import invoiceoutputIndex from './invoiceoutput/index.vue'
	// import postjobIndex from './postjob/index.vue'
	// import joblevelIndex from './joblevel/index.vue'
	// import staffIndex from './staff/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if(this.departmentChildren.length!=0){
				this.activeName = this.departmentChildren[0].controller
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			invoicetypeIndex,
			invoiceinputIndex,
			invoiceoutputIndex,
			// postjobIndex,
			// joblevelIndex,
			// staffIndex,

		}
	}
</script>
